import connector from "@/repository/connector";

export default {
  async list(params = {}) {
    return connector.requestWithFallback(
      () => connector.connector.get("payouts/", { params }),
    );
  },
  async get(id) {
    return connector.requestWithFallback(
      () => connector.connector.get(`payouts/${id}/`),
    );
  },
  async create(payload) {
    return connector.requestWithFallback(
      () => connector.connector.post("payouts/", payload),
    );
  },
};
